import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Coins } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const CreditBadge = () => {
  const { token, user } = useAuth();
  const [balance, setBalance] = useState(null);

  const fetchBalance = useCallback(async () => {
    if (!token) return;
    try {
      const res = await axios.get(`${API_URL}/api/wallet/balance`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setBalance(res.data);
    } catch {
      // Ignore
    }
  }, [token]);

  useEffect(() => { fetchBalance(); }, [fetchBalance]);

  // Refresh every 30 seconds
  useEffect(() => {
    if (!token) return;
    const interval = setInterval(fetchBalance, 30000);
    return () => clearInterval(interval);
  }, [token, fetchBalance]);

  if (!user || !balance) return null;

  const total = balance.total || 0;
  const isLow = total < 200;
  const isCritical = total < 50;

  return (
    <Link
      to="/dashboard?tab=wallet"
      className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium transition-colors ${
        isCritical ? 'bg-[#EF4444]/20 text-[#EF4444] hover:bg-[#EF4444]/30' :
        isLow ? 'bg-[#F59E0B]/20 text-[#F59E0B] hover:bg-[#F59E0B]/30' :
        'bg-[#0055FF]/20 text-[#0055FF] hover:bg-[#0055FF]/30'
      }`}
      data-testid="credit-badge"
    >
      <Coins className="w-3.5 h-3.5" />
      <span>{total.toLocaleString()}</span>
    </Link>
  );
};

export default CreditBadge;
